<ng-container *transloco="let t">
  @if (strategyWarnings().length > 0) {
    <div>
      @for (strategyWarning of strategyWarnings(); track strategyWarning) {
        <div class="alert alert-warning" role="alert">
          <span [class]="ICON_WARNING_TRIANGLE" class="text-orange-500"></span>
          <span class="ml-2">{{ strategyWarning }}</span>
        </div>
      }
    </div>
  }
  @if (strategy(); as strategy) {
    <app-strategy-page
      [campaignType]="CampaignType.SP"
      [strategyGroup]="strategyGroup"
      [strategy]="strategy"
      [withTacticSection]="withTacticSection"
      [withAutoCampaignOption]="withAutoCampaignOption"
      [withProductTargetingOption]="withProductTargetingOption"
    >
      <div withAsins>
        <div class="mb-3 flex h-[35rem] flex-col gap-3">
          <asin-selection-wrapper
            class="min-h-0 flex-1"
            [withDelete]="selectedAsins.length > 0"
            [withAdd]="true"
            [withMove]="selectedAsins.length > 0"
            (deleteClicked)="removeProducts(selectedAsins)"
            (addClicked)="showAddAsinModal()"
            (moveClicked)="moveToOtherStrategy(selectedAsins)"
          >
            <app-asin-selection
              class="min-h-0 flex-1"
              ineligibilityTag="SP"
              [customList]="strategyGroup.asins"
              [readonly]="isReadOnly"
              [(selectedAsins)]="selectedAsins"
              [withBulk]="true"
              [csvExport]="true"
            />
          </asin-selection-wrapper>
        </div>
      </div>
      <div withTargetingStats>
        <app-targeting-asin-stats
          [isReadOnly]="isReadOnly"
          [strategy]="strategy"
          [withTOSROSwitch]="withTOSROSwitch"
        ></app-targeting-asin-stats>
      </div>
    </app-strategy-page>
  }

  <ng-template #productAdd>
    <div class="flex h-[60vh] w-[70vw] flex-col">
      <app-asin-selection
        class="min-h-0 flex-1"
        ineligibilityTag="SP"
        [customList]="strategyType === StrategyType.PRODUCT ? undefined : strategyGroup.asins"
        [disabledAsins]="strategyAsins()"
        [readonly]="isReadOnly"
        [(selectedAsins)]="addAsinList"
        [csvExport]="false"
      />
    </div>
    <div class="flex justify-end gap-2">
      <IButton label="{{ t('common.close') }}" (onClick)="addAsinModalRef?.close()" testid="btn-close" />
      <IButton
        label="{{ t('common.save') }}"
        [disabled]="addAsinList().length === 0"
        (onClick)="addProducts(addAsinList())"
        testid="btn-save"
      />
    </div>
  </ng-template>
</ng-container>
